import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ICategoriaVendaOptions, IDealerOptions, IFiltros, IListaAnos } from '../interface-previsao-venda';
import { ServiceAppService } from '../../../../security/service-app.service';
import { MessageService } from 'primeng/api';

@Component({
  selector: 'app-previsao-venda-filtro',
  templateUrl: './previsao-venda-filtro.component.html',
  styleUrls: ['./previsao-venda-filtro.component.scss']
})
export class PrevisaoVendaFiltroComponent implements OnInit {
  @Input() filtros: IFiltros;
  @Input() exibeFiltros: boolean = true;
  @Output() fecharModalFiltros: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Output() aplicarFiltros: EventEmitter<IFiltros> = new EventEmitter<IFiltros>();
  dealerOptions: IDealerOptions[] = [];
  categoriaVendaOptions: ICategoriaVendaOptions[] = [];
  listaAnos: IListaAnos[] = [];

  constructor(private service: ServiceAppService) { }

  ngOnInit() {
    this.retornaDropDownListas();
  }

  retornaDropDownListas() {
    this.service.getDados(`/filtro/dealer`).subscribe(res => {
      this.dealerOptions = [];
      res.filtros.forEach(res => this.dealerOptions.push({ id_dealer: res.id, nome_dealer: res.descricao }));
    });

    this.service.getDados(`/filtro/categoria_venda`).subscribe(res => {
      this.categoriaVendaOptions = [];
      res.filtros.forEach(res => this.categoriaVendaOptions.push({ id_categoria_venda: res.id, nome_categoria_venda: res.descricao }));
    });

    for (let i = 0; i <= 30; i++) {
      this.listaAnos.push({ descricao: `20${i < 10 ? '0' + i : i}`, ano: 2000 + i });
    }
  }

  hideDialog() {
    this.exibeFiltros = false;
    this.fecharModalFiltros.emit(this.exibeFiltros);
  }

  enviarFiltros() {
    if (this.filtros.mesDate) {
      this.filtros.mes = String(this.filtros.mesDate.getMonth() + 1);
    }
    if (this.filtros.anoNumber) {
      this.filtros.ano = String(this.filtros.anoNumber);
    }

    this.aplicarFiltros.emit(this.filtros);
    this.exibeFiltros = false;
  }

  limpafiltros() {
    const ano = new Date();
    this.filtros = {
      id: '', id_dealer: '', id_categoria_venda: '', mes: '', ano: '', paginaAtual: 1,
      quantidadeRegistrosPorPagina: 10, anoNumber: ano.getFullYear()
    }
    this.aplicarFiltros.emit(this.filtros);
    this.exibeFiltros = false;
  }
}
